
export default class OffCanvasMenu {

    constructor() {
        this.settings = {
            body: document.querySelector('body'),
            el: document.querySelector('[data-block="off-canvas-menu"]'),
            hamburger: document.querySelector('[data-toggle="hamburger"]'),
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.hamburger != null) {
            this.settings.hamburger.addEventListener('click', () => {
                this.settings.body.classList.toggle('overflow');
                this.settings.hamburger.classList.toggle('active');
            });
        }

        const closeIcon = document.querySelector('.js-close-icon');

        closeIcon.addEventListener('click', () => {
            const mobileMenu = document.querySelector('[data-block="off-canvas-menu"]');
            mobileMenu.classList.toggle('open');
        })

    }

};

new OffCanvasMenu();